export const StatusBadge = {
  tag: 'span',
  text: (el, s) => s.status || s.text,
  fontSize: 'Z',
  fontWeight: '600',
  padding: 'Y Z',
  round: 'B',
  whiteSpace: 'nowrap',
  background: (el, s) => {
    const st = s.status || s.text
    if (st === 'Confirmed') return 'green.15'
    if (st === 'Pending') return 'amber.15'
    if (st === 'Completed' || st === 'Paid') return 'inkSurface'
    if (st === 'Cancelled' || st === 'Overdue') return 'red.15'
    return 'inkSurface'
  },
  color: (el, s) => {
    const st = s.status || s.text
    if (st === 'Confirmed') return 'green'
    if (st === 'Pending') return 'amber'
    if (st === 'Completed' || st === 'Paid') return 'inkMuted'
    if (st === 'Cancelled' || st === 'Overdue') return 'red'
    return 'inkMuted'
  }
}
